import React from "react";
import { Color } from "@chesshotel/chess";
import { BBishopIcon } from "@/modules/gameReview/pieceIcons/BBishopIcon";
import { BKingIcon } from "@/modules/gameReview/pieceIcons/BKingIcon";
import { BKnightIcon } from "@/modules/gameReview/pieceIcons/BKnightIcon";
import { BPawnIcon } from "@/modules/gameReview/pieceIcons/BPawnIcon";
import { BQueenIcon } from "@/modules/gameReview/pieceIcons/BQueenIcon";
import { BRookIcon } from "@/modules/gameReview/pieceIcons/BRookIcon";
import { WBishopIcon } from "@/modules/gameReview/pieceIcons/WBishopIcon";
import { WKingIcon } from "@/modules/gameReview/pieceIcons/WKingIcon";
import { WKnightIcon } from "@/modules/gameReview/pieceIcons/WKnightIcon";
import { WPawnIcon } from "@/modules/gameReview/pieceIcons/WPawnIcon";
import { WQueenIcon } from "@/modules/gameReview/pieceIcons/WQueenIcon";
import { WRookIcon } from "@/modules/gameReview/pieceIcons/WRookIcon";

const PIECE_SVG_MAP = {
  K: WKingIcon,
  Q: WQueenIcon,
  R: WRookIcon,
  B: WBishopIcon,
  N: WKnightIcon,
  P: WPawnIcon,
  k: BKingIcon,
  q: BQueenIcon,
  r: BRookIcon,
  b: BBishopIcon,
  n: BKnightIcon,
  p: BPawnIcon,
};

export function PieceSymbol({
  piece,
  color,
  outline = false,
  className = "",
  gapRight = true,
}: {
  piece: string;
  color: Color;
  outline?: boolean;
  className?: string;
  gapRight?: boolean;
}) {
  const normalizedPiece = color === "b" ? piece.toLowerCase() : piece.toUpperCase();
  const PieceIcon = PIECE_SVG_MAP[normalizedPiece];

  if (!PieceIcon) return null;

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        width: "1em",
        height: "1em",
        marginRight: gapRight ? "0.05em" : 0,
        verticalAlign: "0em",
      }}
    >
      <PieceIcon
        color={outline ? "#296ea3" : color === "b" ? "#5F5955" : "#3C3C3C"}
      />
    </span>
  );
}

export function renderSanWithSvg(
  san: string,
  color: Color,
  outline = false,
  lineThrough = false
) {
  if (!san) return san;

  const match = san.match(/^([KQRBN])(.+)/);
  if (!match) return san;

  const piece = match[1];
  const rest = match[2];
  return (
    <span className="inline-block relative">
      {lineThrough && (
        <span className="absolute top-1/2 w-full bg-primary -translate-y-1/2 h-[1.5px]" />
      )}
      <PieceSymbol piece={piece} color={color} outline={outline} />
      {rest}
    </span>
  );
}
